import { styled } from '@mui/material/styles';

export const GradientSpan = styled('span')`
  background-image: ${({ theme }) => theme.palette.single.mainGradient};
  background-color: ${({ theme }) => theme.palette.single.main};
  background-size: 100%;
  background-clip: text;
  text-fill-color: transparent;
`;